<template>
  <div class="common_pop">
    <div class="pop_frame">
      <div class="pop_box">
        <div class="pop_title">{{confirm.title}}</div>
        <div class="content">
          <div class="text">{{confirm.text}}</div>
        </div>
        <div class="pop_button">
          <template v-if="confirm.close">
            <div class="main_btn _info" @click="confirm.close">{{confirm.label_cancel}}</div>
          </template>
          <template v-if="confirm.submit">
            <div class="main_btn" :class="submit_style" @click="confirm.submit">{{confirm.label_submit}}</div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["confirm"]),
    submit_style() {
      return this.confirm.type === "delete" ? "_delete" : "_main"
    }
  }
}
</script>

<style lang="scss">
.common_pop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(#000000, 60%);
  z-index: 100;
  .pop_frame {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100%;
    padding: 1rem 0;
  }
  .pop_box {
    background-color: #ffffff;
    border-radius: 0.6rem;
    padding: 1rem;
    max-width: 20rem;
    width: 90%;
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    .text {
      white-space: pre-line;
      color: $gray_06_dark;
      font-size: 70%;
      letter-spacing: 0;
      text-align: center;
    }
  }
  .pop_button {
    margin-top: 1.2rem;
    display: flex;
    .main_btn {
      font-size: 70%;
      height: 1.8rem;
      line-height: 1.8rem;
      &:not(:first-child) {
        margin-left: 1.6rem;
      }
    }
  }
}
</style>